module.exports = __webpack_public_path__ + "img/acuario_michin.3f9d18e9.jpg";